require("admin/groups/group_detail_row")
require("./webhook_desc_modal")
import {WebhookTemplate} from "./webhook_template"
// Generates a table displaying all webhook templates

export class AllWebhooks extends HTMLElement{
  constructor() {
    super();
  }
  async connectedCallback() {
    this.innerHTML = `<div>
                        <div class="row">
                          <div class="col-sm-12">
                            <h3>Manage Integration Templates</h3>
                            <button id="template-toggle" class="btn btn-primary pull-right template-toggle">Add Template</button>
                          </div>  
                        </div>
                      </div>

                      <div id="temp-div" class="template-toggle">
                        <table id="all_webhooks" class="table" style="width:100%; display:table;">
                            <tfoot style="display: table-header-group;">
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </tfoot>
                            <thead>
                                <tr>
                                  <th></th>
                                  <th>Name</th>
                                  <th>Template Type</th>
                                  <th>Action</th>
                                  <th>In Use</th>
                                </tr>
                            </thead>
                        </table>
                      </div>
                      <webhook-desc-modal></webhook-desc-modal>`
    this.init();
  }
  init() {
    this.table = $('#all_webhooks').DataTable({
      "ajax": "all_templates_for_user",
      "columns": [
        {
          "class": "details-control",
          "orderable": false,
          "data": null,
          "defaultContent": ""
        },
        { "data": "name" },
        { 
          "data": "template_type",
          "class": "text-center"
        },
        {
          data: "is_used",
          "render": function(data, type, row) {
            return `<a class="desc-link">&nbspView</a><span> | </span><a class="edit-link">&nbspEdit</a>${data==true? '':'<span> | </span><a class="del-template">Delete</a>'}`;
          },
          "class": "text-center"

        },
        {
          data: "is_used",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? `<span class="fa ${((data==true) ? "fa-check":"fa-times")}"></span>` : data
          },
          "class": "text-center"
        }
      ],
      initComplete: function () {
        var column = this.api().column(2);
        var select = $('<select><option value="">All Types</option></select>')
            .prependTo( $(column.footer()).empty() )
            .on( 'change', function () {
                var val = $.fn.dataTable.util.escapeRegex(
                    $(this).val()
                );

                column
                    .search( val ? '^'+val+'$' : '', true, false )
                    .draw();
            } );

        column.data().unique().sort().each( function ( d, j ) {
            select.append( '<option value="'+d+'">'+d+'</option>' )
        } );            
      },
      "order": [[1, 'asc']]
    });
    this.table.on('draw', function () {
      $.each(detailRows, function (i, id) {
        $('#' + id + ' td.details-control').trigger('click');
      });
    });

    let detailRows = [];

    $('#all_webhooks tbody').on('click', 'tr td.details-control', async function (e) {
      let tr = $(e.target).closest('tr');
      let row = this.table.row(tr);
      let idx = $.inArray(tr.attr('id'), detailRows);

      if (row.child.isShown()) {
        tr.removeClass('details shown');
        row.child.hide();

        detailRows.splice(idx, 1);
      }
      else {
        let oldSelectedTr = $("table#all_webhooks tr.shown");
            if(oldSelectedTr.size() > 0) {
              let oldSelectedRow = this.table.row(oldSelectedTr);
              oldSelectedTr.next('tr').removeClass('details-row');
              oldSelectedRow.child.hide();
              oldSelectedTr.removeClass('shown');
            }
        tr.addClass('details shown');
        let row_detail = document.createElement("group-detail-row");
        row_detail.id = row.data().action_template_id;

        // Get selected groups
        let groups = await fetch(`/admin/action_templates/${row_detail.id}/template_groups`);
        let group_ids = await groups.json();
        row_detail.current_selected_groups = group_ids.map(group => group.group_id);

        // Get selected industries
        row_detail.show_industries = true;
        let industries = await fetch(`/admin/action_templates/${row_detail.id}/template_industries`);
        let industry_ids = await industries.json();
        row_detail.current_selected_industries = industry_ids.map(industry => industry.industry_id);
        row_detail.url = `/admin/action_templates/${row_detail.id}/template_items`;
        row.child(row_detail).show();

        if (idx === -1) {
          detailRows.push(tr.attr('id'));
        }
      }
    }.bind(this));

    // Opens a modal with the template description of the target row
    $('#all_webhooks tbody').on('click', 'tr td a.desc-link', async function (e) {
      e.preventDefault();
      let row = this.table.row(e.target.closest('tr')).data();
      this.querySelector("webhook-desc-modal").showTemplate(row.template, row.template_type);
      console.log(row)
    }.bind(this));
    // Fills in and opens template edit element
    $('#all_webhooks tbody').on('click', 'tr td a.edit-link', async function (e) {
      e.preventDefault();
      let row = this.table.row(e.target.closest('tr')).data();
      let webhook_template = new WebhookTemplate(row.name, row.template_type, row.template, row.action_template_id);
      this.appendChild(webhook_template);
      this.hideSelf();
    }.bind(this));
    // Delete template
    $('#all_webhooks tbody').on('click', 'tr td a.del-template', async function (e) {
      if(confirm("Are you sure you want to delete this template?")) {
        e.preventDefault();
        let row = this.table.row(e.target.closest('tr')).data();
        let res = await fetch(`/admin/action_templates/${row.action_template_id}`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    'Content-type': 'application/json'},
          method: 'DELETE',
        });
        let data = await res.json();
        console.log(data);
        this.reloadData();
      }
    }.bind(this));
    // Open empty template creation element
    this.querySelector("#template-toggle").addEventListener("click", function() {
      let webhook_template = new WebhookTemplate();
      this.appendChild(webhook_template);
      this.hideSelf();
    }.bind(this));
  }
  showSelf() {
    this.querySelectorAll(".template-toggle").forEach(elem => elem.style.display = "initial");
  }
  hideSelf() {
    this.querySelectorAll(".template-toggle").forEach(elem => elem.style.display = "none");
  }
  reloadData() {
    this.table.ajax.reload();
  }
}

customElements.define("all-webhooks", AllWebhooks)